import React, { useState, useEffect } from 'react';

import Input from 'components/partials/input/input';

import {
  formatNumberWithSuffix,
  parseFormattedNumber,
  formatWithThousandSeparator,
} from 'components/partials/formatted-input/formatted-input.helpers';

interface FormattedTextInputProps {
  value?: number | string;
  onChange?: (value: number | string) => void;
  errorsNames?: Record<string, unknown>;
  disabled?: boolean;
  withSuffix?: boolean;
  [key: string]: unknown;
}

const FormattedTextInput = ({
  value: initialValue,
  onChange = () => {},
  errorsNames,
  disabled,
  withSuffix = true,
  ...props
}: FormattedTextInputProps): React.JSX.Element => {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (initialValue) {
      const numValue = Number(initialValue);
      const formattedValue = withSuffix
        ? formatNumberWithSuffix(numValue)
        : formatWithThousandSeparator(initialValue);

      setInputValue(formattedValue);
    } else if (!Number.isNaN(Number(initialValue))) {
      setInputValue('');
    }
  }, [initialValue]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;
    const cleanedValue = value.replace(/,/g, '');

    setInputValue(formatWithThousandSeparator(cleanedValue));

    if (!!errorsNames) {
      onChange(value);
    }
  };

  const handleBlur = (): void => {
    const parsedValue = parseFormattedNumber(inputValue.replace(/,/g, ''));

    onChange(parsedValue);
    if (!Number.isNaN(parsedValue)) {
      const numParsedValue = Number(parsedValue);
      const formattedValue = withSuffix
        ? formatNumberWithSuffix(numParsedValue)
        : formatWithThousandSeparator(numParsedValue);

      setInputValue(formattedValue);
    }
  };

  return (
    <Input
      {...props}
      disabled={disabled}
      value={inputValue}
      onChange={handleInputChange}
      errorsNames={errorsNames}
      onBlur={handleBlur}
    />
  );
};

export default FormattedTextInput;
